<template>
  <b-modal
    id="materials-modal"
    ref="modal"
    v-model="visible"
    :title="title"
    @hidden="hide"
    @shown="onShow"
    size="lg"
  >
    <ValidationObserver
      ref="materialsForm"
      tag="form"
      @submit.prevent="onSubmit"
      id="materialsForm"
    > 
      <b-row no-gutters class="mb-3">
        <b-col cols="lg-3">
        </b-col>
        <b-col>
          <b-form-checkbox
            v-if="!isEdited"
            id="checkbox-1"
            v-model="addMore">
          Nie zamykaj po dodaniu materiału
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-form-group v-if="!isEdited && !file || isEdited && !editedItem.image && !file" label-cols-lg="3" label="Zdjęcie:" label-for="photo" label-align-lg="right">
        <label class="col" for="file" id="filelabel" >
        <div class="dropfile" @drop="dropFile"  @dragover="dragover" @dragleave="dragleave">
          <div class="d-flex flex-wrap">
            <div class="dropfile-icon">
              <i class="far fa-images"></i>
            </div>
            <div class="dropfile-text">
              <h5>Przeciągnij i upuść plik, aby go dodać</h5>
            </div>
          </div>
          <input ref="file" type="file" name="file" id="file" class="inputfile" @input="onFileChange" />
          <span class="btn btn-primary mt-3">Wybierz zdjęcie</span>
        </div>
        </label>
      </b-form-group>

      <b-form-group v-if="file || isEdited && editedItem.image" label-cols-lg="3" label="Zdjęcie:" label-for="photo" label-align-lg="right">
        <b-form-file style="display: none;" multiple :file-name-formatter="formatNames"></b-form-file>
          <div class="dropfile-edit">
            <img :src="url || editedItem && editedItem.image" />
            <b-button class="btn" @click="removeFile">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </div>
      </b-form-group>

      <b-form-group
        label-cols-lg="3"
        label="Kategoria:"
        label-for="material_category"
        label-align-lg="right"
      >
        <ValidationProvider name="material" rules="required" v-slot="validationContext">
          <multiselect
            id="categories"
            ref="multi"
            placeholder="Kategoria"
            label="name"
            track-by="value"
            :options="options"
            :close-on-select="true"
            :value="defaultValue"
            @input="onInput"
          >
            <template slot="option" slot-scope="props">
              <span v-html="props.option.html"></span>
            </template>
            <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
          </multiselect>
          <b-form-invalid-feedback :force-show="true">&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>

      <b-form-group
        label-cols-lg="3"
        label="Nazwa:"
        label-for="material_name"
        label-align-lg="right"
      >
        <ValidationProvider name="material_name" rules="required" v-slot="validationContext">
          <b-form-input id="material_name" v-model="form.material_name" type="text"></b-form-input>
          <b-form-invalid-feedback :force-show="true">&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>

      <b-form-group
        label-cols-lg="3"
        label="Cena sprzedaży:"
        label-for="sell_price"
        label-align-lg="right"
      >
        <ValidationProvider name="sell_price" rules="required" v-slot="validationContext">
          <b-input-group :prepend="getMainBaseCurrency">
            <b-form-input
              class="col-lg-5"
              id="sell_price"
              v-model.number="form.sell_price"
              :formatter="formatNumber"
              @blur="toRounding('sell_price')"
              type="text"
            ></b-form-input>
          </b-input-group>
          <b-form-invalid-feedback :force-show="true">&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>

      <b-form-group
        v-if="!isEdited"
        label-cols-lg="3"
        label="Ilość:"
        label-for="material_amount"
        label-align-lg="right"
      >
        <ValidationProvider name="material_amount" rules="required" v-slot="validationContext">
          <b-form-input
            class="col-lg-6"
            id="material_amount"
            v-model.number="form.amount"
            :formatter="formatNumber"
            type="text"
          ></b-form-input>
          <b-form-invalid-feedback :force-show="true">&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>
    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button :disabled="isDisabled || isNotChanged || isBusy" size="md" variant="primary" type="submit" form="materialsForm">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
import { numberFormat, zfill } from "@/services/helpers";
import { flatenCategories } from "@/utils/index.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ModalMaterials",
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      editedItem: null,
      visible: false,
      isBusy: false,
      form: { selected: null },
      search: "",
      file: null,
      url: null,
      addMore: false
    };
  },
  computed: {
    ...mapGetters("materials", ["root"]),
    ...mapGetters("company", [ "getMainBaseCurrency"]),
    title() {
      return this.isEdited
        ? "Edytuj materiał: " + this.editedItem.name
        : "Dodaj nowy materiał";
    },
    defaultValue() {
        return this.options.find((option) => option.value === this.form.selected);
    },
    isEdited() {
      return !!this.editedItem;
    },
    options() {
      const [, ...rest] = flatenCategories(this.root, 0);
      return [...rest];
    },
    isDisabled() {
      const { amount, material_name, sell_price, selected } = this.form;
      return (
        amount === undefined ||
        !material_name ||
        sell_price === undefined ||
        !selected
      );
    },
    isNotChanged() {
      if (this.isEdited) {
        if (this.file) return false;
        const { amount, material_name, sell_price, selected } = this.form;
        const { quantity, name, price, category_id, image } = this.editedItem;
        if (image === null) return false;
        return (
          amount === quantity &&
          material_name === name &&
          sell_price === price &&
          selected === category_id
        );
      }
      return false;
    }
  },
  methods: {
    ...mapActions("materials", ["add"]),
    show(editedItem) {
      this.visible = true;
      this.file = null;
      this.url = null;
      this.addMore = false;
      this.isBusy = false;
      this.editedItem = editedItem ? { ...editedItem } : null;
      if (editedItem) this.setModalValues();
    },
    hide() {
      this.false = true;
      this.editedItem = null;
      this.file = null;
      this.url = null;
      this.form = { selected: null };
    },
    setModalValues() {
      const { category_id, quantity, name, price } = this.editedItem;
      
      this.form = {
        selected: category_id,
        amount: quantity,
        material_name: name,
        sell_price: parseFloat(price).toFixed(2)
      };
    },
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      if (this.isEdited) {
        this.$refs.multi.value = this.options.find((option) => option.value === this.editedItem.category_id);
      }
    },
    onInput(data) {
      this.form.selected = data.value; 
    },
    onClose() {},
    onSubmit() {
      this.$refs.materialsForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.isBusy = true;
        const { amount, material_name, sell_price, selected } = this.form;
        this.$Progress.start();
        const bodyFormData = new FormData();
        if (!this.isEdited) bodyFormData.set("quantity", amount);
        bodyFormData.set("name", material_name);
        bodyFormData.set("price", sell_price);
        bodyFormData.set("category_id", selected);

        if (this.file) {
          bodyFormData.append("image", this.file);
        }

        if (this.isEdited && this.editedItem.image === null && !this.file) {
          bodyFormData.set("image", null);
        }

        this.add({
          id: this.isEdited ? this.editedItem.id : null,
          bodyFormData
        }).then(() => {
          if (this.isEdited || !this.addMore) {
            this.visible = false;
            return;
          }
          this.file = null;
          this.url = null;
          this.isBusy = false;
          this.form = { selected: null };
          this.$refs.materialsForm.reset();
        });
      });
    },
    onFileChange() {
      this.file = this.$refs.file.files[0];
      this.url = URL.createObjectURL(this.file);
    },
    removeFile() {
      this.file = null;
      this.url = null;
      if (this.isEdited && this.editedItem.image) this.editedItem.image = null;
    },
    dropFile(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onFileChange();
      event.currentTarget.classList.remove("on");
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("on")) {
        event.currentTarget.classList.add("on");
      }
    },
    dragleave(event) {
      event.preventDefault();
      event.currentTarget.classList.remove("on");
    },

    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    formatNumber: numberFormat,
    toRounding: function(inputName) {
      this.form[inputName] = zfill(this.form[inputName]);
    }
  }
};
</script>
